"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
require("./hyperlink.css");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
} // Ant Design components:
// Custom Turing CSS styles
// Hyperlink - Link component
function Hyperlink(props) {
  // Defining variables ---
  var disabled = props.disabled ? true : false,
    style = '',
    defaultStyle = '',
    secondaryStyle = '',
    width = '',
    title = '',
    path = '',
    openIn = '',
    cssWrap = [],
    cssLink = [];
  // --- end of Defining variables

  // Assigning values ---

  // default values

  style = 'default';
  width = 'inline';
  openIn = 'parent';
  cssWrap.push('turing-link-wrap');
  cssLink.push('turing-link');

  // prop values

  if (props.deafult) {
    defaultStyle = props["default"];
    cssLink.push('default');
    style = 'default';
  }
  if (props.secondary) {
    secondaryStyle = props.secondary;
    cssLink.push('secondary');
    style = 'secondary';
  }
  if (props.secondary) {
    secondaryStyle = props.secondary;
    cssLink.push('secondary');
    style = 'secondary';
  }
  if (props.width) {
    width = props.width;
    cssWrap.push(width);
  }
  if (props.title) {
    title = props.title;
  }
  if (props.path) {
    path = props.path;
  }
  if (props.openIn) {
    openIn = props.openIn;
  }

  // Joining classes to string
  cssWrap = cssWrap.join(' ');
  cssLink = cssLink.join(' ');

  // --- end of Assigning values

  // Passing handlers to component

  var handlers = {};
  for (var prop in props) {
    if (typeof props[prop] === "function") Object.assign(handlers, _defineProperty({}, prop, props[prop]));
  }

  // Building component strucutre

  return buildComponent(style, title, path, openIn, cssWrap, cssLink, handlers);
}

/* Build compnent strucure - function */

function buildComponent(style, title, path, openIn, cssWrap, cssLink, handlers) {
  if (openIn == 'parent') {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: cssWrap
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, _extends({
      className: cssLink,
      to: path,
      title: title
    }, handlers), /*#__PURE__*/_react["default"].createElement("span", null, title)));
  } else if (openIn == 'new-tab') {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: cssWrap
    }, /*#__PURE__*/_react["default"].createElement("a", _extends({
      className: cssLink,
      href: path,
      title: title,
      target: "_blank",
      rel: "noopener noreferrer external"
    }, handlers), /*#__PURE__*/_react["default"].createElement("span", null, title)));
  }
}
var _default = exports["default"] = Hyperlink;